import { getSentryClient } from './SentryLoader';
import { Environment } from '../utils/Environment';

// Needs to be loaded once for the whole library
let loaded = false;

const getClient = async () => {
  const allowUrls = ['https://assets.primer.io/'];
  return getSentryClient({
    dsn: Environment.get('SENTRY_DSN'),
    allowUrls,
    debug: true,
  });
};

export const initErrorMonitoring = () => {
  if (loaded) {
    return;
  }
  loaded = true;

  window.addEventListener('error', async (event) => {
    // We don't want to catch "Script error." errors, because they may come
    // from the website the SDK is integrated in.
    if (
      event.message === 'Script error.' ||
      !event.filename ||
      event.lineno === 0
    ) {
      return;
    }

    // Sentry is lazy loaded when the first error occurs
    try {
      const client = await getClient();
      client.captureException(event.error);
    } catch (e) {}
  });
};
